/**
 * CORE-353 — chat link-preview helpers for the Agape.ChatApi thread.
 *
 * GetStream used to auto-enrich a pasted URL into an og:video/og:image
 * attachment server-side, which `AgapellaAttachment` then rendered as a
 * lightweight poster + click-to-play. After the AI/DM chat moved to
 * Agape.ChatApi (CORE-371/396) that enrichment is gone — a pasted practice link
 * arrives as plain text with no attachment, so the preview disappeared
 * (reported by QA, 2026-07-04). We restore it client-side: detect an Agapella
 * practice link in the message text and render a preview from the practice's
 * own cover + playback URL (no scraping, no backend change).
 */

// A practice deep-link: https://<agapella-host>/practices/<id>[?query].
// Host-scoped to our own domains so we never try to preview a random URL that
// merely contains "/practices/". Matches app.agapella.io, agapella.io, and the
// dev stand rn-agape.vercel.app (all contain "agape").
const PRACTICE_URL_RE = /https?:\/\/([a-z0-9.-]+)\/practices\/(\d+)/gi;

/**
 * Extract unique practice ids (in first-seen order) from a message body. Returns
 * [] for empty text or non-Agapella hosts.
 */
export function extractPracticeIds(text: string | null | undefined): number[] {
  if (!text) return [];
  const ids: number[] = [];
  PRACTICE_URL_RE.lastIndex = 0;
  let m: RegExpExecArray | null;
  while ((m = PRACTICE_URL_RE.exec(text)) !== null) {
    const host = (m[1] || '').toLowerCase();
    if (!host.includes('agape')) continue;
    const id = Number(m[2]);
    if (id > 0 && !ids.includes(id)) ids.push(id);
  }
  return ids;
}
